<template>
  <InlineEdit
    :field="field"
    :value="value"
    :input-size="inputSize"
    v-bind="$attrs"
    @change="$emit('change', $event)"
  >
    <template v-slot:item-renderer="{ item, edit }">
      <div
        class="border-b border-t-0 border-l-0 border-r-0 border-solid border-neutral-lighter flex my-1 py-1 pr-2"
      >
        <div class="flex-1">{{ item || '---' }}</div>
        <div v-if="!disabled" class="action">
          <MTooltip>
            <template v-slot:trigger>
              <MIcon
                name="pencil"
                class="cursor-pointer text-neutral-light"
                @click="edit"
              />
            </template>
            {{ $t('edit') }}
          </MTooltip>
        </div>
      </div>
    </template>
  </InlineEdit>
</template>

<script>
import InlineEdit from '@components/inline-edit/inline-edit'
export default {
  name: 'Host',
  components: { InlineEdit },
  props: {
    value: { type: String, default: undefined },
    field: {
      type: String,
      default() {
        return this.$tc('host_name')
      },
    },
    disabled: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: false },
    inputSize: {
      type: String,
      default() {
        return undefined
      },
    },
  },
}
</script>
